"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBlossomMessages = void 0;
const environment_util_1 = require("../utils/environment.util");
const dapp_blossom_messages_1 = require("./dapp-blossom-messages");
const e2e_blossom_messages_1 = require("./e2e-blossom-messages");
function createBlossomMessages(extensionId) {
    if ((0, environment_util_1.isServiceWorkerEnv)()) {
        return new e2e_blossom_messages_1.E2EBlossomMessages(extensionId);
    }
    else if ((0, environment_util_1.isWebPageEnv)()) {
        return new dapp_blossom_messages_1.DappBlossomMessages();
    }
    throw new Error('Blossom: The current environment is not supported.');
}
exports.createBlossomMessages = createBlossomMessages;
